import { GetApiCall, PostApiCall } from "./axiosSetup";

export const GET_ACTIVE_GAMES = '/game/get-active-games';
export const GET_CATEGORIES = '/game/get-categories';
export const GET_SUB_GATEGORIES = '/game/get-sub-categories';
export const START_GAME = '/game/start-game';
export const START_GAME_FOR_FUN = '/game/start-game-for-fun';

export const GetGames = async () => GetApiCall(GET_ACTIVE_GAMES);
export const GetCategories = async () => GetApiCall(GET_CATEGORIES);
export const GetSubCategories = async () => GetApiCall(GET_SUB_GATEGORIES);
export const StartGame = async (data) => PostApiCall(START_GAME, data);
export const StartGameForFun = async (data) => PostApiCall(START_GAME_FOR_FUN, data);